const common = {
  search: 'Suchen...',
  select: 'Auswählen',
  selectDropdown: 'Auswählen...',
  loading: 'Lädt...',
  selected: '{{count}} ausgewählt ',
  noOptions: 'Keine Optionen',
  all: 'Alle',
  allWithName: 'Alle {{name}}',
  add: 'Hinzufügen',
  selectAll: 'Alles auswählen',
  unselectAll: 'Auswahl aufheben',
  blank: 'Leer',
  enter: 'Eingeben',
  items: '{{count}} Elemente, ',
  shortWeekdays: ['M', 'D', 'M', 'D', 'F', 'S', 'S'],
  distanceType: {
    metric: 'Km',
    imperial: 'Mi',
  },
  hour: 'Stunde',
  reductions: {
    h: 'h',
    m: 'm',
    s: 's',
  },
  connectorStatus: {
    free: 'Verfügbar',
    busy: 'Nicht verfügbar',
    unknown: 'Unbekannt',
    error: 'Defekt',
  },
  yes: 'Ja',
  no: 'Nein',
  weekDays: {
    sunday: 'Sonntag',
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
  },
  internal: 'Intern',
  google: 'Google',
  operationAddress: {
    student: 'Schüleradresse',
    employee: 'Mitarbeiteradresse',
  },
  map: {
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    fullScreen: 'Vollbild',
    measureDistance: 'Entfernung messen',
    polygon: {
      exceededModal: {
        body: 'Der Umfang eines "Block"-Bereichs darf 10 km nicht überschreiten',
        cancel: 'Abbrechen',
      },
      deleteModal: {
        header: 'Polygon löschen?',
        body: 'Sie sind dabei, das Polygon zu löschen',
      },
    },
  },
  roles: {
    // Keys are all lowercase due to processing that handles role names provided by the backend as space-separated strings.
    dispatchadmin: 'Dispatch-Admin',
    dispatcher: 'Disponent',
    superagent: 'Super-Agent',
    agent: 'Agent',
    supplier: 'Anbieter',
    superadmin: 'Super-Admin',
    accountingadmin: 'Buchhaltungs-Admin',
    accountant: 'Buchhalter',
    companyadmin: 'Unternehmens-Admin',
    admin: 'Administrator',
  },
  duration: 'Dauer',
  distance: 'Distanz',
};

export default common;
